import 'firebase/firestore';
import ConfirmDlg from '@/components/popup/confirm-dialog/ConfirmDlg.vue';
import { FamilyNewsletterOptionsEnum } from '@/consts/newsletter';
import { disableFamilyNewsletterOption } from '@/utils/disableFamilyNewsletterOption';
import { setFamilyEngagementCategory } from './FamilyEngagementCoreService';

export default {
  name: 'FamilyEngagementPlus',
  components: { ConfirmDlg },
  props: {
    settings: null,
    arecheckedesdisabled: Boolean,
    facility: null,
    facilityCopy: null
  },
  created() {
    this.sendDefaultValueForModule();
  },
  computed: {
    isFacilityHasCareAPI() {
      return this.$store.state.facilityModule.isFacilityHasCareAPI;
    },
    familyBundle: {
      get() {
        return (
          this.familyEngagementCategory &&
          this.communicationCategory
        );
      }
    },
    communicationCategory: {
      get() {
        return (
          (this.facility.familyChatEnabled ?? true) &&
          (this.facility.scheduledCallsEnabled ?? true) &&
          (this.facility.residentCanTakePhoto ?? true) &&
          (this.facility.isResidentChat ?? true) &&
          (this.facility.isEnableFamilyNewsletter ?? true)
        );
      }
    },
    familyEngagementCategory: {
      get() {
        const f = this.facility;

        const conditions = [
          f.featureFamilyEngagement,
          f.canStaffMessageFamily,
          f.isStaffCanLogInOnBehalfOfResident,
          f.residentConsentCheckbox,
          f.isStaffHubContentManagerGallery,
          f.isStaffHubSurveys,
          f.mediaEnabled,
          f.isStaffHubContentManagerMediaLibrary,
          f.isStaffHubDocuments,
          f.isEnabledDocumentsTile,
          f.isEnabledMyHubFamilyTile,
          f.isEnabledFamilyToResidentMessaging,
          f.isUsingIntercom,
        ];

        return conditions
          .filter(v => v !== undefined && v !== null)
          .every(Boolean);
      }
    }
  },
  methods: {
    sendDefaultValueForModule() {
      this.$emit('send-bundle-value', this.familyBundle)
    },
    familyEngagementCoreBundleUpdate(value) {
      this.familyEngagementCategoryUpdate(value);
    },
    familyEngagementCategoryUpdate(value) {

      setFamilyEngagementCategory(this.facility, value)
   
      if(value) {
        this.$emit('send-bundle-value', this.familyBundle)
      }
    },
    scheduledCallsUpdate(value) {
      if (!value) {
        disableFamilyNewsletterOption(this.facility, FamilyNewsletterOptionsEnum.VideoCalls);
      }
    },
    onIsStaffCanLogInOnBehalfOfResidentChange(value) {
      if(this.facilityCopy.isStaffCanLogInOnBehalfOfResident === value){
        return;
      }

      if (value === true) {
        this.$refs.confirmationModal
          .open(null, this.$t('Settings.FacilitySettings.StaffCanLogInOnBehalfOfResidentsPopUp'), false, "", null, null)
          .then(response => {
            this.facility.isStaffCanLogInOnBehalfOfResident = !!(response && response.agree)
          });
      }
      else if (value === false) {
        this.$refs.confirmationModal
          .open(null, this.$t('Settings.FacilitySettings.OnDisableStaffCanLogInOnBehalfOfResidentsPopUp'), false, "", null, null)
          .then(response => {
            this.facility.isStaffCanLogInOnBehalfOfResident = !!(response && response.agree)
          });
      }
    },
  }
};
